module.exports = __webpack_public_path__ + "web/img/AI驳回.e9a3cd16.png";